<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Close Episode
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
          </div>
          <div class="col-10">
            <div class="text-center mb-3">
              <span class="available-funds">Available Episode Funds:</span><span class="available-funds-amount"> ${{formatNumber(balance)}}</span><br />

              <div class="my-3">To close the episode, select a payee to send the remaining episode balance.</div>
            </div>
            <b-form-group :label-cols="4" label="Services" label-align="right" :state="stateForField('organizationBundleServiceId')" :invalid-feedback="errorForField('organizationBundleServiceId')">
              <b-dropdown menu-class="dropdown-container" :text="serviceName"
                          :variant="hasError('organizationBundleServiceId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="service in services" :key="service.organizationBundleServiceId"
                                 @click.prevent="setService(service)">{{service.bundleService.serviceType.name}}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Payee" label-align="right" :state="stateForField('organizationPayeeId')" :invalid-feedback="errorForField('organizationAccountId')">
              <b-dropdown menu-class="dropdown-container" :text="payeeName"
                          :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="payee in payees" :key="payee.organizationPayeeId"
                                 @click.prevent="setPayee(payee)">{{ payeeDisplayName(payee) }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Account" label-align="right" :state="stateForField('organizationAccountId')" :invalid-feedback="errorForField('organizationAccountId')">
              <span v-if="accounts.length === 0 && payeeName !== 'Select Payee' ">
                <div class="account-label">No Account on File</div>
              </span>
              <span v-if="accounts.length === 1">
              <div class="account-label">{{ selectedAccount.name + ' (' + selectedAccount.last4 + ')' }}</div>
              </span>
              <span v-if="accounts && accounts.length > 1">
              <b-dropdown  menu-class="dropdown-container" :text="accountName"
                           :variant="hasError('organizationAccountId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="account in accounts" :key="account.organizationAccountId"
                                 @click.prevent="setAccount(account)">{{ account.name + ' (' + account.last4 + ')'  }}
                </b-dropdown-item>
              </b-dropdown>
              </span>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Send Payment
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'

  export default {
    name: 'CloseEpisodeModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      paymentDistributionId: {
        type: Number,
        required: true
      },

      account: {
        type: Object,
        required: false
      },

      payment: {
        type: Object,
        required: false
      },

      services: {
        type: Array,
        required: true
      },

      balance: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        transfer: {},
        payees: [],
        accounts: [],
        status: {},
        payeeName: 'Select Payee',
        accountName: 'Select Account',
        selectedAccount: {},
        serviceName: 'Select Service',
        isSaving: false
      }
    },

    methods: {
      validate () {
        if (!this.transfer.amount) {
          this.addErrorForField('amount', 'You must enter an amount')
        }
        if (!this.transfer.account.name) {
          this.addErrorForField('organizationAccountId', 'You must select an account')
        }

        if (this.transfer.amount > this.$props.distributionAmount) {
          this.addErrorForField('amount', 'Amount exceeds distribution amount')
        }

        return !this.hasErrors()
      },

      loadPayees () {
        api.get('/Dashboard/Payees').then(response => {
          this.payees = response.data.filter(payee => payee.accounts.length > 0)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
        })
      },

      updateStatus () {
        api.post('/Dashboard/PaymentDistribution/' + this.paymentDistributionId + '/Close').then(response => {
          this.status = response.data
          this.$emit('updatePaymentSent')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
          this.isSaving = false
        })
      },

      save () {
        if (this.isSaving) {
          return
        }
        this.clearAllErrors()
        this.isSaving = true

        api.post('/Dashboard/PaymentDistribution/' + this.paymentDistributionId + '/Pay', this.transfer).then(response => {
          this.updateStatus()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to fund payment distribution: ' + error.message, error)
          }
        })
      },

      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      },

      payeeDisplayName (payee) {
        let displayName = ''
        if (payee.businessName) {
          displayName = payee.businessName
        }

        if (payee.firstName) {
          if (displayName) {
            displayName += ', '
          }
          displayName += payee.firstName
        }

        if (payee.lastName) {
          displayName += ' ' + payee.lastName
        }

        return displayName
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      setService (service) {
        this.serviceName = service.bundleService.serviceType.name
        this.transfer.organizationBundlePaymentDistributionServiceId = service.organizationBundlePaymentDistributionServiceId
        this.transfer.organizationAccountId = service.organizationAccountId
        this.transfer.amount = this.$props.balance
      },

      setPayee (payee) {
        this.payeeName = this.payeeDisplayName(payee)
        this.accounts = payee.accounts
        if (this.accounts && this.accounts.length === 1) {
          this.setAccount(this.accounts[0])
        } else if (this.accounts && this.accounts.length > 1) {
          this.accountName = 'Select Account'
        }
      },
      setAccount (account) {
        this.selectedAccount = account
        this.transfer.organizationAccountId = account.organizationAccountId
        this.accountName = account.name + ' (' + account.last4 + ')'
      }
    },

    created () {
      this.loadPayees()
    }
  }
</script>

<style scoped>
.available-funds {
  color: #2A84F4;
  font-weight: 500;
  font-size: 18px;
}
.available-funds-amount {
  font-weight: 500;
  font-size: 18px;
}

.covered-services-amount-input {
  width: 60%;
}

.account-label {
  font-size: 1rem;
  margin-top: 6px;
}
</style>
